import React, { useState } from 'react';
import './WeatherForecast.css';
import WeatherForecastPreview from "./WeatherForecastPreview";
import axios from 'axios';

export default function WeatherForecast(props) {
    const [loaded, setLoaded] = useState(false);
    const [forecast, setForecast] = useState(null);



    function displayForecast(response) {
        setForecast(response.data);
        setLoaded(true);
    }

    if (loaded && props.city === forecast.city.name) {
        return (
            <div className="WeatherForecast row">
                <WeatherForecastPreview data={forecast.list[0]} units={props.units} />
                <WeatherForecastPreview data={forecast.list[1]} units={props.units} />
                <WeatherForecastPreview data={forecast.list[2]} units={props.units} />
                <WeatherForecastPreview data={forecast.list[3]} units={props.units} />
                <WeatherForecastPreview data={forecast.list[4]} units={props.units} />
                <WeatherForecastPreview data={forecast.list[5]} units={props.units} />
            </div>);

    } else {
        let apiKey = '9f983349ddb8c26dfc6cae681695c977';
        let url = `https://api.openweathermap.org/data/2.5/forecast?q=${props.city}&appid=${apiKey}&units=metric`;
        axios.get(url).then(displayForecast);
        return null;
    }


}